/** Imię i nazwisko z konta użytkownika (podpis elektroniczny / etykieta) */
export function formatUserFullName(user) {
  if (!user) return '';
  const n = [user.firstName, user.lastName].filter(Boolean).join(' ').trim();
  return n || user.username || user.email || '';
}

/**
 * Tekst pod podpisem: najpierw zapis z serwera (kto faktycznie podpisał),
 * inaczej — zalogowany użytkownik (świeży podpis przed pierwszym zapisem).
 * Gdy brak podpisu — undefined (nie pokazuj „kto podpisze”, dopóki nie ma podpisu).
 */
export function formatSignerNameUnderPad(podpis, imieNazwiskoZapisane, zalogowanyUser) {
  if (podpis == null || podpis === '') return undefined;
  const z = imieNazwiskoZapisane && String(imieNazwiskoZapisane).trim();
  if (z) return z;
  return formatUserFullName(zalogowanyUser) || undefined;
}
